// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__chLiP","label":"TextArea_label__ZPHZY","input":"TextArea_input__EeJwX","error":"TextArea_error__PdnkV"};